// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 此处后端没有提供注释 GET /api/pes/accessToken/currentLoginUserInfo */
export async function getApiPesAccessTokenCurrentLoginUserInfo(options?: {
  [key: string]: any;
}) {
  return request<API.UserInfoDto>("/api/pes/accessToken/currentLoginUserInfo", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/pes/accessToken/saveLoginUser */
export async function postApiPesAccessTokenSaveLoginUser(options?: {
  [key: string]: any;
}) {
  return request<API.CommonResultDto>("/api/pes/accessToken/saveLoginUser", {
    method: "POST",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/pes/accessToken/syncEmployeeFromAzureProxy */
export async function postApiPesAccessTokenSyncEmployeeFromAzureProxy(options?: {
  [key: string]: any;
}) {
  return request<boolean>("/api/pes/accessToken/syncEmployeeFromAzureProxy", {
    method: "POST",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/pes/accessToken/userListByKeyWords */
export async function getApiPesAccessTokenUserListByKeyWords(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getApiPesAccessTokenUserListByKeyWordsParams,
  options?: { [key: string]: any }
) {
  return request<API.CommonOptionsDto1String[]>(
    "/api/pes/accessToken/userListByKeyWords",
    {
      method: "GET",
      params: {
        // currentRole has a default value: *
        currentRole: "*",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 POST /api/pes/accessToken/userLogOut */
export async function postApiPesAccessTokenUserLogOut(options?: {
  [key: string]: any;
}) {
  return request<API.CommonResultDto>("/api/pes/accessToken/userLogOut", {
    method: "POST",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/pes/accessToken/userMenuTrees */
export async function getApiPesAccessTokenUserMenuTrees(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getApiPesAccessTokenUserMenuTreesParams,
  options?: { [key: string]: any }
) {
  return request<API.MenuTreeDto[]>("/api/pes/accessToken/userMenuTrees", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/pes/accessToken/usersByEmail */
export async function getApiPesAccessTokenUsersByEmail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getApiPesAccessTokenUsersByEmailParams,
  options?: { [key: string]: any }
) {
  return request<API.RelationUserOutDto>("/api/pes/accessToken/usersByEmail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
